// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a8ebd79","453":"8fc17b2a","455":"fbf89a0d","977":"a0e55d8f"}[chunkId] + ".chunk.js";
};